.wrapper {
  display: flex;
}
